module.exports = __webpack_public_path__ + "static/media/instagram-icon.aec0965a.svg";